module.exports = __webpack_public_path__ + "static/media/MD_TutorialSlides_10202020_08.5_Sequencer.e9feac75.png";